import { Button, Form, Input, message, Space } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";

const SettingsProgMain = ({ progId, onClose, isMobile }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState(null);

  const getData = () => {
    if (!progId) return;

    setLoading(true);
    serverFetch(`dict/prog/${progId}`)
      .then((data) => {
        setItem(data);
        form.setFieldsValue(data);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  useEffect(() => {
    if (progId) {
      getData();
    }
  }, [progId]);

  const onValuesChange = (changedValues, allValues) => {
    // Обновляем локальные данные программы при изменении полей
    setItem(prev => ({ ...prev, ...changedValues }));
  };

  const onSave = () => {
    if (!item) return;
    
    setLoading(true);
    serverFetch(`dict/prog`, {
      method: "PUT",
      bodyData: item
    })
      .then(() => {
        setLoading(false);
        message.success("Программа обновлена");
        if (onClose) {
          onClose(true); // Закрываем форму и обновляем список
        }
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  const onCancel = () => {
    if (onClose) {
      onClose(false);
    }
  };

  const formProps = isMobile
    ? { layout: "vertical", colon: false, disabled: loading, style: { width: "100%", maxWidth: "100%" } }
    : {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
        colon: false,
        disabled: loading,
        style: { maxWidth: 600 },
      };

  return (
    <Form form={form} onValuesChange={onValuesChange} {...formProps}>
      <Form.Item label="#">
        <Input value={item?.id} disabled />
      </Form.Item>
      
      <Form.Item 
        label="Название" 
        name="name"
        rules={[{ required: true, message: 'Введите название программы!' }]}
      >
        <Input />
      </Form.Item>
      
      <Form.Item label="Описание" name="description">
        <Input.TextArea rows={3} />
      </Form.Item>
      
      <Form.Item label=" ">
        <Space>
          <Button type="primary" onClick={onSave} loading={loading}>
            Сохранить
          </Button>
          <Button onClick={onCancel}>
            Отмена
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default SettingsProgMain;
